<template>
  <div>
    <!-- 上传控件 -->
    <el-upload
      class="upload-demo"
      :action="uploadUrl"
      :data="uploadData"
      name="file"
      accept=".png, .jpg, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .msg, .py, .mp4, .avi, .mp3, .amr, .wav, .jpg, .JPG, .png, .PNG, .jpeg, .rar, .pdf, .PDF, .zip, .ZIP, .7z"
      :multiple="true"
      :before-remove="beforeRemoveUploadFile"
      :with-credentials="true"
      :show-file-list="false"
      :on-success="uploadSuccess"
      :disabled="disabled"
      :before-upload="beforeUpload"
    >
      <el-button size="small" type="primary" v-if="!disabled">点击上传</el-button>
      <div
        slot="tip"
        class="el-upload__tip"
        v-if="!disabled"
      >只能上传.doc, .docx, .xls, .xlsx, .ppt, .pptx，视频，音频文件，且不超过20Mb</div>
    </el-upload>
    <el-table
      v-if="showUploadTable"
      :header-cell-style="{background:'#eee',color:'#606266',height:'20px'}"
      v-loading="loading"
      :data="uploadedFileList"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column prop="fileName" label="文件名称"></el-table-column>
      <el-table-column width="80px">
        <template slot-scope="scope">
          <el-button size="small" type="text">
            <a href="#" @click="download(scope.row.guid,scope.row.fileName)">下载</a>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import Config from "@/components/Config.vue";
import DateUtils from "@/plugins/DateUtils.vue";
export default {
  data() {
    return {
      loading: false,
      showUploadTable:false,
      uploadedFileList: [],
      uploadData: {
        tenant: "portal",
        name: "",
        description: ""
      },
      uploadUrl: Config.apiUrl + "/api/store/v0.1/upload/"
    };
  },
  // directives: {
  //   uploadListDiv: {
  //     componentUpdated: function (el, bindings, vnode) {
  //       const dealStyle = function (tags) {
  //         tags.forEach((el, index) => {
  //           debugger
  //           if (![el.classList].includes("el-upload-list__item-download")) {
  //             let href=this.uploadedFileList[index].guid;
  //             let a= document.createElement("a");
  //             a.setAttribute("href","test");
  //             a.setAttribute("target","_blank");
  //             a.innerHTML="下载"

  //             let elName= el.querySelector('.el-upload-list__item-name')
  //             //
  //             el.insertBefore(a, elName.nextSibling)
  //             el.classList.add("el-upload-list__item-download");

  //           }
  //         });
  //       };
  //       setTimeout(() => {
  //         const tagTemp = el.querySelectorAll(".el-upload-list__item");
  //         dealStyle(tagTemp);
  //       });
  //     },
  //   },
  // },
  props: {
    fileIds: Array,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.getUploadFileList();
  },
  methods: {
    beforeUpload(file) {
      this.showUploadTable=true;
      this.loading = true;
    },
    //File upload successfull
    uploadSuccess(response, file, uploadedFileList) {
      this.loading = false;
      if (response.errcode == 0) {
        let res = response.data;
        this.fileIds.push(res.guid);
        this.$emit("getUploadFileIds", this.fileIds);
        // this.getUploadFileList();
        this.$message.success(file.name + "上传成功。");
      } else {
        let fileNew = {};
        fileNew.name = file.name;
        fileNew.guid = "";
        this.uploadedFileList.push(fileNew);
        this.uploadedFileList.pop();
        this.$message.error("上传失败:" + response.errmsg);
      }
    },
    //File Delete
    beforeRemoveUploadFile(guid) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.removeUploadFile(guid);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
      return false;
    },
    //File confirm deleteFile
    removeUploadFile(guid) {
      this.$axios
        .post("/api/store/v0.1/delete", "tenant=portal&guid=" + guid)
        .then(res => {
          var js = res.data;

          if (js.errcode == 0) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            if (this.fileIds.indexOf(guid) > -1) {
              this.fileIds.splice(this.fileIds.indexOf(guid), 1);
            }
            for (var i = 0; i < this.uploadedFileList.length; i++) {
              if (this.uploadedFileList[i].guid == guid) {
                this.uploadedFileList.splice(i, 1);
              }
            }
            this.$emit("getUploadFileIds", this.fileIds);
            if(this.uploadedFileList.length<=0){
              this.showUploadTable=false;
            }
          } else {
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error"
            });
          }
        });
    },
    //File getList
    getUploadFileList() {
      // this.showUploadTable=false;
      this.uploadedFileList = [];
      if (this.fileIds.length === 0) return false;
      this.loading = true;
      this.$axios
        .get("/api/store/v0.1/getUploadList", {
          params: {
            tenant: "portal",
            fileIds: this.fileIds.join(",")
          }
        })
        .then(res => {
          var js = res.data;
          this.loading = false;
          if (js.errcode == 0) {
            var arrT = js.data;
            if (!arrT || arrT.length == 0) return;
            
            for (let i = 0; i < arrT.length; i++) {
              let fileNew = {};
              fileNew.fileName = arrT[i].fileName;
              fileNew.guid = arrT[i].guid;
              if(arrT[i].pdfPath){
                let pdfUrl =
                Config.portalUrl + "/upload/audit/" + arrT[i].pdfPath;
              fileNew.pdfUrl =
                Config.portalUrl +
                "/static/pdfjs-3/web/viewer.html?file=" +
                encodeURIComponent(pdfUrl);
              }else{
                fileNew.pdfUrl='';
              }

              fileNew.created = arrT[i].created;
              fileNew.creatorName = arrT[i].creatorName;
              this.uploadedFileList.push(fileNew);
            }
            if(this.uploadedFileList.length>0){
              this.showUploadTable=true;
            }
          } else {
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error"
            });
          }

        });
    },
    //File Preview
    download(guid, fileName) {
      this.$axios
        .post("/api/store/v0.1/download", "tenant=portal&guid=" + guid, {
          responseType: "blob"
        })
        .then(res => {
          if (res.status == 200) {
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", fileName); // 自定义下载文件名（如exemple.txt）
            document.body.appendChild(link);
            link.click();
          }
        });
    }
  },
  watch: {
    fileIds() {
      this.getUploadFileList();
    }
  },
  filters: {
    formatDate(time) {
      return DateUtils.formatDate(time, "YYYY-MM-DD HH:mm:ss");
    }
  }
};
</script>
<style scoped>
.el-upload-list__item-name {
  float: left;
}
.el-table__header tr,
.el-table__header th {
  height: 20px;
  line-height: 20px;
}
.showT{
  display: block;
}
.hiddT{
  display: none;
}
</style>
